import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

export function DMTReceiptModal({
  receiptData = null,
  isOpen = false,
  onClose = () => {},
  title = "DMT Transaction Receipt",
  logoUrl = "/assets/images/logo/2.png",
}) {
  const receiptRef = useRef();

  const safe = (v, def = "N/A") =>
    v === null || v === undefined || v === "" ? def : v;

  const formatCurrency = (amount) => {
    if (!amount || amount === "null") return "₹0.00";
    return `₹${parseFloat(amount).toFixed(2)}`;
  };

  const getStatusClass = (status) => {
    if ((status || "").toLowerCase() === "success") return "text-success";
    if ((status || "").toLowerCase() === "failed") return "text-danger";
    return "text-warning";
  };

  const mapTransactionType = (type) => {
    switch ((type || "").toLowerCase()) {
      case "money_transection":
        return "Money Transfer (DMT)";
      default:
        return safe(type);
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: "DMT Receipt",
        text: "Here is your DMT transaction receipt",
        url: window.location.href,
      });
    } else {
      alert("Sharing not supported");
    }
  };

  const handlePrint = () => {
    if (!receiptRef.current) return;
    const printContents = receiptRef.current.innerHTML;
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        </head>
        <body>${printContents}</body>
      </html>
    `);
    win.document.close();
    win.print();
  };

  const handleDownload = () => {
    if (!receiptRef.current) return;
    html2pdf()
      .set({
        margin: 0.5,
        filename: "dmt-receipt.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      })
      .from(receiptRef.current)
      .save();
  };

  if (!isOpen) return null;

  const data = receiptData || {};

  const tableData = [
    { label: "Transaction Type", value: mapTransactionType(data.transection_type) },
    { label: "Order ID", value: safe(data.order) },
    { label: "Transaction No", value: safe(data.txn_nu) },
    { label: "Sender Mobile", value: safe(data.SenderMobile) },
    { label: "Sender Name", value: safe(data.SenderName) },
    { label: "Beneficiary Name", value: safe(data.BeneficiaryName) },
    { label: "Account No", value: safe(data.AccountNo) },
    { label: "IFSC Code", value: safe(data.BeneIFSC) },
    { label: "Bank Name", value: safe(data.bank_name) },
    { label: "Shop Name", value: safe(data.shop_name) },
    { label: "Bank RRN", value: safe(data.bank_rrn) },
    { label: "Amount", value: formatCurrency(data.amount) },
    { label: "Charge", value: formatCurrency(data.Charge) },
    { label: "Date & Time", value: safe(data.created_at) },
    {
      label: "Status",
      value: (data.status || "").toUpperCase(),
      isStatus: true,
    },
  ];

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        ref={receiptRef}
        className="modal-dialog modal-fullscreen-md-down"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">

          {/* HEADER */}
          <div className="modal-header">
            <h4 className="main-title">{title}</h4>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body p-0">
            <div className="container invoice-container">
              <div className="card">
                <div className="card-body">

                  <table className="table w-100">
<tbody>
                    {/* TOP HEADER */}
                    <tr>
                      <td>
                        <table className="table w-100">
                          <tr>
                            <td>
                              <img
                                src={logoUrl}
                                alt="LOGO"
                                style={{ width: 200, height: 60, objectFit: "contain" }}
                              />
                              <address>Customer Copy – DMT Receipt</address>
                            </td>
                            <td className="text-end">
                              <h3 className="text-primary">RECEIPT</h3>
                              <p><strong>{safe(data.created_at)}</strong></p>
                              <p>
                                <strong className={getStatusClass(data.status)}>
                                  {(data.status || "").toUpperCase()}
                                </strong>
                              </p>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    {/* MAIN TABLE */}
                    <tr>
                      <td>
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th>Description</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData.map((row, i) => (
                              <tr key={i}>
                                <td><strong>{row.label}</strong></td>
                                <td>
                                  {row.isStatus ? (
                                    <span className={getStatusClass(row.value)}>
                                      <strong>{row.value}</strong>
                                    </span>
                                  ) : (
                                    row.value
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* FOOTER NOTE */}
                    <tr>
                      <td>
                        <div className="text-center p-3 bg-light rounded">
                          <strong>Note:</strong> This is a system generated DMT receipt.
                        </div>
                      </td>
                    </tr>
</tbody>
                  </table>
                </div>
              </div>

              {/* ACTION BUTTONS */}
              <div className="float-end my-3">
                <button className="btn btn-primary m-1" onClick={handlePrint}>Print</button>
                <button className="btn btn-secondary m-1" onClick={handleShare}>Share</button>
                <button className="btn btn-success m-1" onClick={handleDownload}>Download</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
